import script from "./PlMark.vue?vue&type=script&setup=true&lang=js"
export * from "./PlMark.vue?vue&type=script&setup=true&lang=js"

import "./PlMark.vue?vue&type=style&index=0&id=e8d8e4a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8d8e4a0"]])

export default __exports__